import { useTheme } from '@mui/material/styles';
import { ZendeskBootstrap } from './ZendeskBootstrap';
import { getAppConfig } from '../../config';
import { FCNC } from '../../ui';

export const Zendesk: FCNC = () => {
    const { zenDeskKey } = getAppConfig();
    const theme = useTheme();
    const launcherColor = theme.palette.brandSecondary?.main ?? theme.palette.primary.main;
    const setting = {
        webWidget: {
            color: {
                theme: launcherColor,
                launcher: launcherColor,
                launcherText: '#FFFFFF',
            },
        },
    };

    // eslint-disable-next-line react/jsx-props-no-spreading
    return zenDeskKey ? <ZendeskBootstrap defer zendeskKey={zenDeskKey} {...setting} /> : null;
};
